/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = MergingItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MergingItemsEditor extends _Ext.ItemGridEditor<MergingItemsRow> {
        bagno: string;



        protected getColumnsKey() { return "Production.MergingItems"; }
        protected getDialogType() { return MergingItemsDialog; }
        protected getLocalTextPrefix() { return MergingItemsRow.localTextPrefix; }
        protected form: MergingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            //this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }

        private Master;
        public setEditValue(source: DismantlingRow, property) {
            //   super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }
     
     
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }




        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Select Sub Bags",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => { 
                    // **** Validate Party before Item Selection ****
                    this.bagno = (this.parentDialog as MergingDialog).form.BagNo.value;
                    var departmentid = (this.parentDialog as MergingDialog).form.DepartmentId.value;
                    if (this.bagno==undefined||this.bagno=="") {
                        Q.notifyWarning("Please select Work Order to proceed");
                        return;
                    }
                    if (this.bagno == undefined || this.bagno == "") {
                        Q.notifyWarning("Please select Department to proceed");
                        return;
                    }
                    else {
                        var grid = WIPMovementSelectSubBags;
                        var filters: _Ext.SelectGridFilters = {
                            BagNo: this.bagno,
                            DepartmentId: Q.parseInteger(departmentid)
                        } 
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        for (var i = 0; i < selectedItems2.length; i++) {
                            this.setnewitem(selectedItems2[i] )
                        }
                    }
                    pickerDialog.dialogOpen();
                },
            });
            return buttons;
        }
        setnewitem(selectedrow: MergingItemsRow) {
            var value = selectedrow;
            var newbom = [];
            let bomdetails: WIPTransactionRow[];
            WIPTransactionService.MFGBOMList({ BagNo: selectedrow.BagNo, SubBagNo: selectedrow.SubBagNo }, response => bomdetails = response.Entities, { async: false });

            if (bomdetails != undefined) {
                for (var j = 0; j < bomdetails.length; j++) {
                    var oldbom = bomdetails[j];
                    var bom: MergingBOMRow = {
                        BagNo: selectedrow.BagNo,
                        BomProductId: oldbom.ProductId,
                        ItemTypeId: oldbom.ItemTypeId,
                        AttributeId: oldbom.AttributeId,
                        CompanyId: oldbom.CompanyId,
                        FinancialYearId: oldbom.FinancialYearId,
                        Line_No: oldbom.Line_No,
                        Pieces: oldbom.Pieces  ,
                        Weight: oldbom.Weight ,
                        ProductId: oldbom.ProductId,
                        PureWeight: oldbom.PureWeight,
                        Purity: oldbom.Purity,
                        SettingId: oldbom.SettingId,
                        Lab: oldbom.Lab,
                        StoneStatusId: oldbom.StoneStatusId,
                        CertificateNo: oldbom.CertificateNo,
                        //RefTransBomId: oldbom.RefTransBomId,
                        RefTransId: oldbom.RefTransId,
                        RefTransItemId: oldbom.RefTransItemId,
                        RefVoucherId: oldbom.RefVoucherId,
                        IsCustomerItem: oldbom.IsCustomerItem
                    };
                    newbom.push(bom);
                }
            }

            var item: MergingItemsRow = {
                ProductId: value.ProductId,
                ProductCode: value.ProductCode,
                AttributeId: value.AttributeId,
                ItemTypeId: value.ItemTypeId,
                Line_No: value.Line_No,
                BagNo: value.BagNo,
                SubBagNo: value.SubBagNo,
                DepartmentId: selectedrow.DepartmentId,
                Pieces: value.Pieces,
                EmployeeId: 0,
                Weight: value.Weight,
                Parts: value.Parts,
                OtherPieces: value.OtherPieces,
                OtherWeight: value.OtherWeight,
                StonePieces: value.StonePieces,
                StoneWeight: value.StoneWeight,
                NetWeight: value.NetWeight,
                DiamondPieces: value.DiamondPieces,
                DiamondWeight: value.DiamondWeight,
                RefTransId: value.RefTransId,
                RefTransItemId: value.RefTransItemId,
                RefVoucherId: value.RefVoucherId,
                DeliveryDate: value.DeliveryDate == undefined ? "1/1/2021 9:00:00.2492948 AM" : value.DeliveryDate,
                POSCustomerId: value.POSCustomerId,
                LedgerName: value.LedgerName,
                RefVoucherNo: value.RefVoucherNo,
                Attribute: value.Attribute,
                Purity: value.Purity,
                PureWeight: value.PureWeight,
                TreeId: value.TreeId,
                TreeItemId: value.TreeItemId,
                TreeNo: value.TreeNo,
                BOMDetails: newbom
            };

            item[this.getIdProperty()] = "`" + this.nextId++;
            this.view.addItem(item);
        }
    }
}